import React from 'react'

type Props = {
    size    : string,
    message : string,
}

export default class UILoading extends React.Component<Props> {

    static defaultProps = {
        size    : "normal",
        message : "Loading ..."
    }

    render() {
        switch (this.props.size) {
            default:
                return (
                    <div className="gd-loading">
                        <img src="/app/web/skin/common/loader/app-loading.gif?3" width={40} />
                        <p>{this.props.message}</p>
                    </div>
                )
        }
    }
}